var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipseInRhombus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.82843 9.17194L9.17157 2.8288C10.7337 1.2667 13.2663 1.2667 14.8284 2.8288L21.1716 9.17194C22.7337 10.734 22.7337 13.2667 21.1716 14.8288L14.8284 21.1719C13.2663 22.734 10.7337 22.734 9.17157 21.1719L2.82842 14.8288C1.26633 13.2667 1.26633 10.734 2.82843 9.17194Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2322 3.88946L3.88909 10.2326C2.91278 11.2089 2.91277 12.7918 3.88908 13.7681L10.2322 20.1113C11.2085 21.0876 12.7915 21.0876 13.7678 20.1113L20.1109 13.7681C21.0872 12.7918 21.0872 11.2089 20.1109 10.2326L13.7678 3.88946C12.7915 2.91315 11.2085 2.91315 10.2322 3.88946ZM9.17157 2.8288L2.82843 9.17194C1.26633 10.734 1.26633 13.2667 2.82842 14.8288L9.17157 21.1719C10.7337 22.734 13.2663 22.734 14.8284 21.1719L21.1716 14.8288C22.7337 13.2667 22.7337 10.734 21.1716 9.17194L14.8284 2.8288C13.2663 1.2667 10.7337 1.2667 9.17157 2.8288Z",
    fill: "#56777F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4.25,
    stroke: "#56777F",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseInRhombus);
export default __webpack_public_path__ + "static/media/ellipse_in_rhombus.a997b2de2bf63d1d3332f9a47aa09dc3.svg";
export { ForwardRef as ReactComponent };